import React from 'react'
import logo from '../../Resources/Image/logo.jpg'

const Header = () => {
    return (
        <nav>
            <img src={logo} alt="logo" width="200"/>
        </nav>
    )
}

export default Header
